export default __webpack_public_path__ + "static/media/snd_00014.29bec888.mp4";